<template>
  <div>
    <v-toolbar dense class="primary mb-5" dark flat>
      Current Employment
    </v-toolbar>
    <v-form ref="form" v-model="valid">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="form.name"
            :rules="rules"
            label="Employer Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="form.title"
            :rules="rules"
            label="Title"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="form.salary"
            type="number"
            :rules="rules"
            label="Monthly Salary"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.start"
                :rules="rules"
                outlined
                label="Start Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.start"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-form>
    <EmploymentHistory v-model="employmentHistory" />
    <OtherSource class="mt-5" v-model="otherIncome" />
    <v-btn @click="$emit('step', 3)" class="mr-5" color="primary">Back</v-btn>
    <v-btn color="green" dark @click="submit()">Continue</v-btn>
  </div>
</template>

<script>
import EmploymentHistory from "./EmploymentHistory";
import OtherSource from "./OtherSource";
export default {
  components: { EmploymentHistory, OtherSource },
  data() {
    return {
      form: {
        name: "",
        salary: "",
        title: "",
        start: ""
      },
      ans: "",
      valid: false,
      employmentHistory: [],
      otherIncome: [],
      types: ["Rent", "Own"],
      min: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      rules: [v => !!v || "Field is required"],
      emailRules: [
        v => !!v || "Field is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  watch: {
    employmentHistory(val) {
      console.log(val);
    },
    otherIncome(val) {
      console.log(val);
    }
  },
  methods: {
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.valid) return;
      let form = vm.$store.getters.form;
      form.employment = vm.form;
      form.employmentHistory = vm.employmentHistory;
      form.otherIncome = vm.otherIncome;
      vm.$store.commit("setForm", form);
      vm.$emit("step", 5);
    }
  },
  mounted() {
    const vm = this;
    let form = vm.$store.getters.form;
    form.employment = vm.form;
    form.employmentHistory = vm.employmentHistory;
    form.otherIncome = vm.otherIncome;
    vm.$store.commit("setForm", form);
  }
};
</script>

<style></style>
